import Footer from "../../components/common/Footer";
import NavMenu from "../../components/navbar/NavMenu";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";
import TitleBar from "../../components/navbar/TitleBar";
import TrackAllStops from "../../components/stops/TrackAllStops";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";

export default function StopsAllTrack() {
  const location = useLocation();
  const isSchoolApp = new URLSearchParams(location.search).get("app") === "school";
  const NavigationMenu = isSchoolApp ? SchoolBusNavMenu : NavMenu;

  return (
    <>
      <TitleBar />
      <NavigationMenu />
      <TrackAllStops isSchoolApp={isSchoolApp} />
      <Box sx={{ height: "10vh" }}></Box>
      <Footer />
    </>
  );
}